import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlPatternService {
  private readonly urlPattern =
    /https:\/\/knackbrava-dev\.knackintradev\.com\/occ\/v2\/brava-customer\/knbr\/customer\/\d+\/carts\/\d+\?.*fields=DEFAULT.*/;

  isBlockedUrl(url: string): boolean {
    return this.urlPattern.test(url);
  }
}
